import { Validator, RequiredRule } from "devextreme-react/validator";
import TextBox from "devextreme-react/text-box";
import { Button } from 'devextreme-react';

export const FilterNameControls = ({ 
    filterName, 
    setFilterName, 
    onSave, 
    onShare, 
    onDelete, 
    showShareAndDelete = true 
}) => {
    return (
        <div style={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            padding: "1rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            border: "1px solid #dee2e6",
            marginBottom: "1rem",
            flexShrink: 0
        }}>
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                flexWrap: "wrap"
            }}>
                {/* Filter Name Input */}
                <div style={{ flex: 1, minWidth: "250px" }}>
                    <label style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#495057",
                        marginBottom: "0.25rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.25rem"
                    }}>
                        <span style={{
                            color: "#dc3545",
                            fontSize: "14px"
                        }}>*</span>
                        Filter Name
                    </label>
                    <TextBox
                        onChange={(e) => setFilterName(e.component._changedValue)}
                        placeholder="Enter filter name"
                        defaultValue={filterName}
                        width="100%"
                        height={32}
                        stylingMode="outlined"
                    >
                        <Validator>
                            <RequiredRule IsRequired="true" message="Filter name is required" />
                        </Validator>
                    </TextBox>
                </div>

                {/* Action Buttons */}
                <div style={{
                    display: "flex",
                    gap: "0.5rem",
                    alignItems: "flex-end",
                    paddingBottom: "2px"
                }}>
                    <Button
                        icon="save"
                        text="Save"
                        onClick={onSave}
                        hint="Save this filter configuration"
                        stylingMode="contained"
                        type="success"
                        height={32}
                    />
                    {showShareAndDelete && (
                        <>
                            <Button
                                icon="share"
                                text="Share"
                                onClick={onShare}
                                hint="Share this filter with others"
                                stylingMode="outlined"
                                height={32}
                            />
                            <Button
                                icon="trash"
                                text="Delete"
                                onClick={onDelete}
                                hint="Delete this filter"
                                stylingMode="outlined"
                                type="danger"
                                height={32}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
